import React, { Component } from 'react';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import { validate } from '../lib/clientValidator';
import VxCheckboxField from './vxFields/VxCheckboxField';
import VxRadioField from './vxFields/VxRadioField';
import VxBasicSelectField from './vxFields/VxBasicSelectField';
import VxBasicInputField from './vxFields/VxBasicInputField';
import ButtonPreviewContainer from './buttonPreview/ButtonPreviewContainer';
import PropTypes from 'prop-types';
import { BTN_FACTORY_FORM } from '../clientConstants';
import { connect } from 'react-redux';
import getLocaleMessages from '../utils/localesMessages';
import { getValuesFromULState } from '../../utility/queryStringHelper';
import { isLoggedInUser } from '../utils/authUtils';
import { initialState } from '../reducers/reducerButtonFactory';
import _get from 'lodash/get';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import _includes from 'lodash/includes';
import { trackWizardStep } from '../utils/ButtonFactoryFPT';
import { setTitleCase } from '../utils/commonUtils';

const {
	header,
	subTitle,
	advance,
	radio: {
		paypalButtonStyle,
		ownButtonStyle,
		largeValue,
		smallValue
	},
	buttonSize: {
		label
	},
	cardLogoCheckbox,
	buttonImgURL,
	country: countryProperty,
	language: languageProperty
} = getLocaleMessages('buttons/wizardStepOne');

const getOptionsForCountriesField = (countryAndLanguageDetails) => {
	const countriesByCode = countryAndLanguageDetails.countriesByCode;
	const countryCodes = _keys(countriesByCode);

	return _map(countryCodes, (countryCode) => {
		return {
			value: countryCode,
			displayValue: _get(countriesByCode, `${countryCode}.name`)
		}
	})
}

/**
 * Fetch select options for language field based on the country selection
 */
export const getOptionsForLanguageField = (countryAndLanguageDetails, selectedCountry) => {
	const countriesByCode = countryAndLanguageDetails.countriesByCode;
	
	selectedCountry = selectedCountry || 'US';

	const allLanguages = countriesByCode[selectedCountry].languages;
	const languageCodes = _keys(allLanguages);

	return _map(languageCodes, (languageCode) => {
		return {
			value: languageCode,
			displayValue: setTitleCase(allLanguages[languageCode].name)
		}
	})
}

const mapStateToProps = (state) => {
	const formValues = getFormValues(BTN_FACTORY_FORM)(state);
	const countryAndLanguageDetails = _get(state, 'application.countryAndLanguageDetails');
	const countryCode = _get(formValues, 'countryCode') || _get(state.buttonFactory, 'formattedButton.countryCode');

	return {
		initialValues: state.buttonFactory.formattedButton,
		formValues,
		application: state.application,
		optionsForCountry: getOptionsForCountriesField(countryAndLanguageDetails),
		optionsForLanguage: getOptionsForLanguageField(countryAndLanguageDetails, countryCode)
	}
}


class WizardStep1 extends Component {
	static propTypes = {
		handleSubmit: PropTypes.func,
		usePaypalButtonStyle: PropTypes.bool,
		buttonSize: PropTypes.string,
		showAcceptedCardLogos: PropTypes.bool,
		initialValues: PropTypes.object,
		formValues: PropTypes.object,
		application: PropTypes.object,
		change: PropTypes.func,
		history: PropTypes.object,
		dispatch: PropTypes.func,
		optionsForCountry: PropTypes.array,
		optionsForLanguage: PropTypes.array
	}

	componentDidMount() {
		if (window.location.href.indexOf('/login') === -1) {
			this.resumeUserStateOnLogin();
		}
		trackWizardStep({
			step: 1
		});
	}

	resumeUserStateOnLogin() {
		const url = window.location.href;
		// These keys are for logged in view only and should not be overwritten
		const keysToIgnore = ['useSettingsLogo', 'settingsLogoUrl', 'logoUrl'];
		const formKeys = Object.keys(initialState.formattedButton);
		const loginFormValues = getValuesFromULState(formKeys, url);

		for (var key in loginFormValues) {
			if (loginFormValues[key] && !_includes(keysToIgnore, key)) {
				this.props.change(key, loginFormValues[key]);
			}
		}

		if (url.indexOf('?') !== -1) {
			const trimmedUrl = url.substring(url.indexOf('/donate'), url.indexOf('?'));
			this.props.history.push(trimmedUrl);
		}
	}

	/**
	 * When country selection is changed, the language selection
	 * in redux-form's store has to be changed by
	 * dispatching "change" action to update the language field
	 */
	handleCountryChange = (event) => {
		const newCountry = event.target.value;
		const countryAndLanguageDetails = _get(this.props, 'application.countryAndLanguageDetails');
		const languages = getOptionsForLanguageField(countryAndLanguageDetails, newCountry);
		// Select first value by default
		let language = _get(languages, '[0].value');
		this.props.dispatch(change(BTN_FACTORY_FORM, 'language', language));
	}

	renderCountryField = (props) => {
		const options = this.props.optionsForCountry;

		return (
			<VxBasicSelectField
				options={options}
				{...props}
			/>
		)
	}

	renderLanguageField = (props) => {
		const options = this.props.optionsForLanguage;

		return (
			<VxBasicSelectField
				options={options}
				{...props}
			/>
		)
	}

	renderUsePayPalButtonStyleField = (props) => {
		return (
			<VxRadioField
				{...props}
			/>
		)
	}

	renderShowAcceptedCardLogos = (props) => {
		return (
			<VxCheckboxField
				{...props}

			/>
		)
	}

	renderButtonSizeField = (props) => {
		return (
			<VxBasicSelectField
				options={[
					{ value: 'large', displayValue: largeValue },
					{ value: 'small', displayValue: smallValue }
				]}
				{...props}
			/>
		)
	}

	renderUseYourOwnButtonField = (props) => {
		return (
			<VxRadioField
				{...props}
			/>
		)
	}

	renderButtonImageUrl = (props) => {
		return (
			<VxBasicInputField
				{...props}
			/>
		)
	}

	shouldDisableAcceptedCardLogos = () => {
		const buttonSize = this.getValue('buttonSize');
		return buttonSize === 'small';
	}

	getValue = (key) => {
		return this.props.formValues ? this.props.formValues[key] : null;
	}

	handleButtonPreviewError = (e) => {
		console.log('handleButtonPreviewError ', e);
	}

	getLanguage = () => {
		const language = this.getValue('language');
		if (language) {
			return language;
		}
		const languages = this.props.optionsForLanguage;
		// Return first language
		return _get(languages, '[0].value');
	}

	render() {
		const { handleSubmit } = this.props;
		const usePaypalButtonStyle = this.getValue('usePaypalButtonStyle');
		const shouldDisableAcceptedCardLogos = this.shouldDisableAcceptedCardLogos();
		const buttonSize = this.getValue('buttonSize');
		const showAcceptedCardLogos = this.getValue('showAcceptedCardLogos');
		const buttonImageUrl = this.getValue('buttonImageUrl');
		const isLoggedIn = isLoggedInUser(this.props.application);

		return (
			<div className="wizard-step-container wizard-step-1-container">
				<div className="wizard-step-title">
					{header}
					{!isLoggedIn &&
						<div className="vx_text-legal">{subTitle}</div>
					}
				</div>
				<div className="wizard-body">
					<div className="wizard-body-left">
						<form onSubmit={handleSubmit} className="wizard-form">
							<Field
								id="countryCode"
								name="countryCode"
								component={this.renderCountryField}
								label={countryProperty}
								onChange={(e) => {
									this.handleCountryChange(e)
								}}
							/>

							<Field
								id="language"
								name="language"
								component={this.renderLanguageField}
								label={languageProperty}
							/>

							<Field
								type="radio"
								id="usePaypalButtonStyle"
								name="usePaypalButtonStyle"
								value="yes"
								checkedValue={usePaypalButtonStyle}
								component={this.renderUsePayPalButtonStyleField}
								label={paypalButtonStyle.label}
							/>

							{usePaypalButtonStyle === 'yes' &&
								<div className="button-style-elements fields-margin-left">
									<Field
										name="buttonSize"
										component={this.renderButtonSizeField}
										label={label}
									/>

									<div className={`show-accepted-card-logos ${buttonSize === 'small' ? 'hide-visibility' : ''}`}>
										<Field
											id="showAcceptedCardLogos"
											name="showAcceptedCardLogos"
											component={this.renderShowAcceptedCardLogos}
											type="checkbox"
											label={cardLogoCheckbox}
											disabled={shouldDisableAcceptedCardLogos}
										/>
									</div>
								</div>
							}

							<Field
								type="radio"
								id="useYourOwnButton"
								name="usePaypalButtonStyle"
								value="no"
								checkedValue={usePaypalButtonStyle}
								component={this.renderUseYourOwnButtonField}
								label={ownButtonStyle.label}
							/>

							{usePaypalButtonStyle === 'no' && <div className="fields-margin-left">
								<Field
									type="text"
									id="buttonImageUrl"
									name="buttonImageUrl"
									component={this.renderButtonImageUrl}
									label={buttonImgURL}
									validateOnBlur={true}
								/>
							</div>}

						</form>
					</div>
					<div className="wizard-body-right">
						<ButtonPreviewContainer
							usePaypalButtonStyle={usePaypalButtonStyle === 'yes'}
							buttonSize={buttonSize}
							showAcceptedCardLogos={!!showAcceptedCardLogos}
							buttonImageUrl={buttonImageUrl}
							onError={this.handleButtonPreviewError}
							locale={this.getLanguage()}
							country={this.getValue('countryCode')}
						/>
					</div>

				</div>

				<div className="wizard-footer-button">
					<button className="vx_btn" type="submit" onClick={handleSubmit} id="nextStep">
						{advance}
					</button>
				</div>

			</div>
		);
	}
}

let WizardStep1Form = reduxForm({
	form: BTN_FACTORY_FORM,
	keepDirtyOnReinitialize: true,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate
})(WizardStep1);

WizardStep1Form = connect(mapStateToProps)(WizardStep1Form);

export default WizardStep1Form;



// WEBPACK FOOTER //
// ./buttons/components/WizardStep1.js